import { red, lightBlue, green, orange } from "@mui/material/colors";
import type { ThemeOptions } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { ptBR } from "@mui/x-date-pickers/locales";

export const themeOptions: ThemeOptions = {
  shape: {
    borderRadius: 4,
  },
  palette: {
    text: {
      primary: "#1B1B1B",
      secondary: "#666666",
      disabled: "#9e9e9e",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    common: {
      black: "#000000",
      white: "#ffffff",
    },
    primary: {
      main: "#2F16C9",
      dark: "#0C1C69",
      light: "#7D4EE4",
    },
    secondary: {
      main: "#0C1B69",
      dark: "#091448",
      light: "#707DBA",
    },
    error: {
      main: red["700"],
      dark: red["900"],
      light: red["400"],
    },
    warning: {
      main: orange["600"],
      dark: orange["900"],
      light: orange["400"],
    },
    info: {
      main: lightBlue["500"],
      dark: lightBlue["900"],
      light: lightBlue["200"],
    },
    success: {
      main: green["800"],
      dark: green["900"],
      light: green["500"],
    },
    white: {
      main: "#fff",
      light: "#00000099",
      contrastText: "#2A774A",
    },
  },
  typography: {
    fontFamily: "Inter",
    h1: {
      fontWeight: 300,
      fontSize: "96px",
      lineHeight: "112.03px",
    },
    h2: {
      fontWeight: 300,
      fontSize: "60px",
      lineHeight: "72px",
    },
    h3: {
      fontWeight: 400,
      fontSize: "48px",
      lineHeight: "52.02px",
    },
    h4: {
      fontWeight: 500,
      fontSize: "28px",
      lineHeight: "34.58px",
    },
    h5: {
      fontWeight: 500,
      fontSize: "24px",
      lineHeight: "32.02px",
    },
    h6: {
      fontWeight: 500,
      fontSize: "20px",
      lineHeight: "32px",
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "24px",
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "19.04px",
    },
    body1: {
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "28px",
    },
    body2: {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20.02px",
    },
    caption: {
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "19.92px",
    },
    overline: {
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "31.92px",
    },
  },
};

export default createTheme(themeOptions, ptBR);
